import React, { useState, useEffect } from 'react';
import { titleCase, flattenString, buildKeywordLink } from '../../../utils/helpers';
import useClickSubmit from '../../../hooks/useClickSubmit';
import useInsightSubmit from '../../../hooks/useInsightSubmit';
import styles from './QuickLinks.css.js';
import Radium from 'radium';
import { useLazyQuery, useMutation } from '@apollo/client';
import GET_OFFER_BY_GROUP from '../../../graphql/GET_OFFER_BY_GROUP';
import ADD_SERVICE_LOG from '../../../graphql/ADD_SERVICE_LOG';
import CircularProgress from '@material-ui/core/CircularProgress';

const LinkButton = ({ isOptOut, link, tracking }) => {
    const [ isHovering, setHovering ] = useState(false);
    const [ shouldExecute, setExecute ] = useState(false);
    const [ offerFound, setStateOffer ] = useState(null);

    const [ addTagToServiceLog ] = useMutation(ADD_SERVICE_LOG, { onCompleted: () => {
        console.log('Offer Service Tag added!');
    }});

    const handleOfferFound = (data, error) => {
        if(data) {
            const offer = data.fetchOfferByGroup.body;
            addTagToServiceLog({ 
                variables: {
                    service: {
                        program_id: offer['program_id'],
                        group_id: offer['group_id'],
                        offer_id: offer['id'],
                        clickId: Number(tracking['hsid'])
                    }
                }
            });
            console.log('offer from Group:', offer);
            setStateOffer(offer);
		};
		if(error) {
			console.error('ERROR fetching Offer from group:', error);
		};
    };

    const [ findOfferGroup, { loading } ] = useLazyQuery(GET_OFFER_BY_GROUP, {
        variables: {
            offer_group: link.offer_group,
            program_id: tracking.program_id,
            user: { location: tracking['location'], clickId: Number(tracking['hsid']) }
        },
        skip: offerFound || tracking['vertical'] === 'lincx',
        onCompleted: handleOfferFound
    });

    useInsightSubmit(link.text, tracking, shouldExecute);
    useClickSubmit(isOptOut, tracking, shouldExecute);

    useEffect(() => {
        if(link.offer_group && link.offer_group !== 'N/A' && !offerFound) {
            findOfferGroup();
        };
        // eslint-disable-next-line
    },[offerFound]);

    const handleClickSubmit = () => {
        setExecute(true);
        const offerLink = offerFound?.url ?? link.url;
        const linkout = buildKeywordLink(offerLink, tracking, flattenString(link.text), isOptOut);
        let newTab = window.open();
        newTab.location = linkout;
        if(!!tracking.r) {
            window.location.href = tracking.r;
        };
    };

    const buttonStyle = Object.assign({},
            styles.linkContainer,
            styles[`${tracking.theme}Button${link.idx}`],
            isHovering && styles.hover
        );

    if(loading) {
        return (
            <div style={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%'
            }}>
                <CircularProgress size={40} thickness={4.5}/>
            </div>
        )
    };
    return (        
        <button
            key={`user-selection-link__${link.idx}`}
            onMouseEnter={() => setHovering(true)}
            onMouseLeave={() => setHovering(false)}
            style={buttonStyle}
            onClick={handleClickSubmit}
        >
            {titleCase(link.text)}
        </button>
    )
};

export default Radium(LinkButton);